import "./SearchResultGroup.html";
import "./SearchResultGroup.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { SearchResultGroupComponentController } from "./SearchResultGroupComponentController";

export class SearchResultGroupComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            areNoResults: "=?areNoResults",
            caption: "<",
            containerClasses: "@",
            icon: "@",
            isDetailedResults: "<",
            searchString: "<",
            type: "<",
            typingOffset: "<",
        };
        this.controller = SearchResultGroupComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Search/SearchResultGroup/SearchResultGroup.html";
    }
}
